import React,{useState} from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Partner from '../../components/partner'
import ClientTwo from '../../components/client-two'
import BgParallax from '../../components/bg-parallax'
import TeamOne from '../../components/team-one'
import PricingTwo from '../../components/pricing-two'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/gym/02.png'
import about from '../../assets/images/gym/03.jpg'
import cta from '../../assets/images/gym/04.jpg'
import gym1 from '../../assets/images/gym/01.png'

import { gymCounter, gymServices } from '../../data/data'

import CountUp from 'react-countup'

import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss'



export default function IndexGym() {
  let [isOpen, setOpen] = useState(false);
  return (
    <>
    <Navbar navLight={true}/> 

    <section className="bg-half-170 d-table pb-0 w-100 bg-dark bg-dark-dark">
      <div className="container">
          <div className="row justify-content-center align-items-center mt-4">
              <div className="col-lg-7 col-md-7 pe-lg-5 order-lg-1 order-md-1 order-sm-2">
                  <div className="title-heading mt-4">
                      <h1 className="heading text-white mb-3 title-dark">We want to keep our body fit</h1>
                      <p className="para-desc text-light title-dark">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="text-center subcribe-form mt-5 mb-lg-4">
                          <form action="#">
                              <input type="text" id="keywords" name="name" className="rounded-pill shadow" required placeholder="Write Email Your In Here"/>
                              <button type="submit" className="btn btn-primary rounded-pill">Subscribe Now</button>
                          </form>
                      </div>
                  </div>
                  <div className="row" id="counter">
                    {gymCounter.map((item,index)=>{
                      return(
                        <div className="col-md-4 col-6" key={index}>
                            <div className="counter-box py-2 pb-md-3">
                                <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={item.value}/>+</h2>
                                <h6 className="counter-head text-light title-dark">{item.title}</h6>
                            </div>
                        </div>
                      )
                    })}
                  </div>
              </div>
              <div className="col-lg-5 col-md-5 order-lg-2 order-md-2 bg-warning rounded-pill order-sm-1">
                  <img src={bg1} className="img-fluid" alt=""/>
              </div>
          </div>
      </div>
    </section>

    <section className="py-5">
      <div className="container">
          <div className="row">
              <div className="col-12">
                  <Partner/>
              </div>
          </div>
      </div>
    </section>

    <section className="section"> 
      <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-5 col-md-6">
                  <div className="position-relative">
                      <img src={about} className="img-fluid shadow-lg rounded-4" alt=""/>
                      <div className="play-icon">
                          <Link to="#" onClick={() => setOpen(true)} className="play-btn lightbox video-play-icon">
                              <i className="mdi mdi-play text-primary rounded-pill bg-white shadow"></i>
                          </Link>
                      </div>
                      <ModalVideo
                        channel="youtube"
                        youtube={{ mute: 0, autoplay: 0 }}
                        isOpen={isOpen}
                        videoId="yba7hPeTSjk"
                        onClose={() => setOpen(false)} 
                      />
                  </div>
              </div>

              <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="section-title ms-md-4">
                      <h5 className="text-primary">About Us</h5>
                      <h4 className="title mb-4">A gym built for working out</h4>
                      <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                      <Link to="#" className="btn btn-primary">Read More</Link>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section bg-light" id="services">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {gymServices.map((item,index)=>{
              return(
                <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                    <div className="feature p-4 rounded">
                        <i className={`uil uil-dumbbell text-primary h1 ${item.icon}`}></i>
                        <div className="content mt-2">
                            <h4 className="title">{item.title}</h4>
                            <p className="text-muted mt-2">{item.desc}</p>
                            <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>
      <div className="container mt-100">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="mb-4 text-dark d-inline-flex">Time Schedule</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row mt-4">
              <div className="col-12">
                  <div className="table-responsive shadow rounded-4">
                      <table className="table-center border-secondary-subtle bg-white text-center mb-0">
                          <thead className="">
                              <tr>
                                  <th className="col py-4 px-4 text-dark border-bottom border-right">Time</th>
                                  <th className="col py-4 px-4 text-dark border-bottom border-right">MON</th>
                                  <th className="col py-4 px-4 text-dark border-bottom border-right">TUE</th>
                                  <th className="col py-4 px-4 text-dark border-bottom border-right">WED</th>
                                  <th className="col py-4 px-4 text-dark border-bottom border-right">THU</th>
                                  <th className="col py-4 px-4 text-dark border-bottom border-right">FRI</th>
                                  <th className="col py-4 px-4 text-dark border-bottom border-right">SAT</th>
                                  <th className="col py-4 px-4 text-dark border-bottom">SUN</th>
                              </tr>
                          </thead>
                          
                          <tbody className="">
                              <tr>
                                  <th className="py-4 px-4 text-dark border-bottom border-right">8:00 Am</th>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Power Yoga</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Cardio</td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Boxing</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Weight Lifting</td>
                                  <td className="py-4 px-4 text-dark border-bottom">Aerobics</td>
                              </tr>
                              <tr>
                                  <th className="py-4 px-4 text-dark border-bottom border-right">10:00 Am</th>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Aerobics</td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Power Yoga</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Cardio</td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Boxing</td>
                                  <td className="py-4 px-4 text-dark border-bottom">Weight Lifting</td>
                              </tr>
                              <tr>
                                  <th className="py-4 px-4 text-dark border-bottom border-right">12:00 Pm</th>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Boxing</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Weight Lifting</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Power Yoga</td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Cardio</td>
                                  <td className="py-4 px-4 text-dark border-bottom">Aerobics</td>
                              </tr>
                              <tr>
                                  <th className="py-4 px-4 text-dark border-bottom border-right">5:00 Pm</th>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Cardio</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Aerobics</td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Weight Lifting</td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Power Yoga</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom">Boxing</td>
                              </tr>
                              <tr>
                                  <th className="py-4 px-4 text-dark border-bottom border-right">8:00 Pm</th>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Weight Lifting</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Power Yoga</td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Boxing</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Aerobics</td>
                                  <td className="py-4 px-4 text-dark border-bottom">Cardio</td>
                              </tr>
                              <tr>
                                  <th className="py-4 px-4 text-dark border-bottom border-right">10:00 Pm</th>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Weight Lifting</td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Boxing</td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Aerobics</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom border-right">Cardio</td>
                                  <td className="border-bottom border-right"></td>
                                  <td className="py-4 px-4 text-dark border-bottom">Power Yoga</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className='position-relative'>
      <BgParallax bg={cta}/>
      <div className="bg-overlay" style={{opacity: '0.8'}}></div>
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-6">
                  <div className="cta-review bg-dark shadow rounded p-4">
                      <ClientTwo/>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section mt-60">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mt-5 pt-4">
                      <h4 className="title mb-4">Our Dream Team</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <TeamOne/>
      </div>
    </section>

    <section className="section bg-light">        
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Rates For You</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <PricingTwo/>
      </div>
  

    <div className="container mt-100 mt-60">
      <div className="bg-dark bg-cta-dark rounded-3 pb-lg-0 pb-sm-0 shadow">
          <div className="row justify-content-center align-items-center">
              <div className="col-lg-3 col-md-4 d-none d-sm-block">
                  <img src={gym1} className="img-fluid" alt=""/>
              </div>
              <div className="col-lg-7 col-md-6 p-4">
                  <div className="text-start ">
                      <h4 className="text-white mx-auto para-desc title-dark">Subscribe And Deily Tips</h4>
                      <p className="text-white-50 mx-auto para-desc para-dark mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-endcomponent library.</p>
                      <div className="text-center subcribe-form mt-5 mb-lg-4">
                          <form action="#">
                              <input type="text" id="keywords1" name="name" className=" rounded-pill" required placeholder="Write Email Your In Here"/>
                              <button type="submit" className="btn btn-primary rounded-pill">Subscribe Now</button>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
    </section>
    
    <section className="section">
      <div className="container">
          <div className="row justify-content-center align-items-center">
              <div className="col-lg-7 col-md-7">
                  <h4 className="title mb-4">The best fitness class is for you</h4>
                  <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                  <div className="progress-box mt-4">
                      <h6 className="title text-muted">Client Satisfaction</h6>
                      <div className="progress">
                          <div className="progress-bar progress-bar-striped position-relative bg-info" style={{width:'90%'}}>
                              <div className="progress-value d-block text-muted h6">90%</div>
                          </div>
                      </div>
                  </div>
                  <div className="progress-box mt-4 mb-4">
                      <h6 className="title text-muted">Customer Support</h6>
                      <div className="progress">
                          <div className="progress-bar progress-bar-striped position-relative bg-primary" style={{width:'95%'}}>
                              <div className="progress-value d-block text-muted h6">95%</div>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-lg-5 col-md-5">
                  <div className="bg-white shadow rounded p-4 position-relative">
                      <div className="text-center">
                          <h4 className="mb-4">Book Your Appointment</h4>  
                      </div>
                      <form>
                          <div className="row">
                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Full Name <span className="text-danger">*</span></label>
                                      <input type="text" className="form-control"  name="name" required="" placeholder="Full Name :"/>
                                  </div>
                              </div>
                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                      <input type="email" className="form-control"  name="email" required="" placeholder="Your Email :"/>
                                  </div>
                              </div>
                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label"> Appointment Date : <span className="text-danger">*</span></label>
                                      <input name="date" type="date" className="form-control start"/>
                                  </div>
                              </div>
                              <div className="col-md-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Age : <span className="text-danger">*</span></label>
                                      <input type="number" min="1" autoComplete="off" id="adult" required="" className="form-control" placeholder="1"/>
                                  </div>
                              </div>
                              <div className="col-md-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Phone : <span className="text-danger">*</span></label>
                                      <input type="text" id="phone" className="form-control" placeholder="+00 123-45-678"/>
                                  </div>
                              </div>
                              <div className="col-12">
                                  <div className="d-grid">
                                      <button className="btn btn-primary">Submit</button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}
